export const GET_ACCOUNTS_PAGE_REQUEST = 'GET_ACCOUNTS_PAGE_REQUEST';
export const GET_ACCOUNTS_PAGE_SUCCESS = 'GET_ACCOUNTS_PAGE_SUCCESS';
export const GET_ACCOUNTS_PAGE_FAILURE = 'GET_ACCOUNTS_PAGE_FAILURE';
export const GET_PAYEES_PAGE_REQUEST = 'GET_PAYEES_PAGE_REQUEST';
export const GET_PAYEES_PAGE_SUCCESS = 'GET_PAYEES_PAGE_SUCCESS';
export const GET_PAYEES_PAGE_FAILURE = 'GET_PAYEES_PAGE_FAILURE';

export const SET_ACCOUNTS_SEARCH_TEXT = 'SET_ACCOUNTS_SEARCH_TEXT';
export const SET_PAYEES_SEARCH_TEXT = 'SET_PAYEES_SEARCH_TEXT';
export const SET_ACCOUNTS_CURRENT_PAGE = 'SET_ACCOUNTS_CURRENT_PAGE';
export const SET_PAYEES_CURRENT_PAGE = 'SET_PAYEES_CURRENT_PAGE';
export const SAVE_LAST_API_ACTION = 'SAVE_LAST_API_ACTION';
export const SET_SHOW_PAYEES = 'SET_SHOW_PAYEES';
export const SET_PAGING_LAYOUT_TYPE = 'SET_PAGING_LAYOUT_TYPE';
export const SET_ACCOUNTS_PAGE_SIZE = 'SET_ACCOUNTS_PAGE_SIZE';
export const SET_PAYEES_PAGE_SIZE = 'SET_PAYEES_PAGE_SIZE';
export const RESET_PAGED_PAYEES = 'RESET_PAGED_PAYEES';
export const SET_FAVOURITE_REQUEST = 'SET_FAVOURITE_REQUEST';
export const SET_FAVOURITE_SUCCESS = 'SET_FAVOURITE_SUCCESS';
export const SET_FAVOURITE_FAILURE = 'SET_FAVOURITE_FAILURE';
export const GET_ACCOUNTS_BY_CAPABILITY_REQUEST = 'GET_ACCOUNTS_BY_CAPABILITY_REQUEST';
export const GET_ACCOUNTS_BY_CAPABILITY_SUCCESS = 'GET_ACCOUNTS_BY_CAPABILITY_SUCCESS';
export const GET_ACCOUNTS_BY_CAPABILITY_FAILURE = 'GET_ACCOUNTS_BY_CAPABILITY_FAILURE';

export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 60;
export const DEFAULT_PAYEES_PAGE_SIZE = 60;

export const GET_ACCOUNT_DETAILS_REQUEST = 'GET_ACCOUNT_DETAILS_REQUEST';
export const GET_ACCOUNT_DETAILS_SUCCESS = 'GET_ACCOUNT_DETAILS_SUCCESS';
export const GET_ACCOUNT_DETAILS_FAILURE = 'GET_ACCOUNT_DETAILS_FAILURE';
export const GET_ACCOUNT_DETAILS_BY_ID_REQUEST = 'GET_ACCOUNT_DETAILS_BY_ID_REQUEST';
export const GET_ACCOUNT_DETAILS_BY_ID_SUCCESS = 'GET_ACCOUNT_DETAILS_BY_ID_SUCCESS';
export const GET_ACCOUNT_DETAILS_BY_ID_FAILURE = 'GET_ACCOUNT_DETAILS_BY_ID_FAILURE';

export const SET_IS_SELECTING_LCV_FROM_ACCOUNT = 'SET_IS_SELECTING_LCV_FROM_ACCOUNT';
